import _ from 'lodash';
import api from '../../utils/service';
import { loadingCycle } from './page';

const CREATE_GUEST_PAYMENT_SUCCESS = 'redux/guestPayment/CREATE_GUEST_PAYMENT_SUCCESS';
const CREATE_GUEST_PAYMENT_FAIL = 'redux/guestPayment/CREATE_GUEST_PAYMENT_FAIL';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CREATE_GUEST_PAYMENT_SUCCESS:
      return {
        ...state,
        result: action.data,
        error: null,
      };
    case CREATE_GUEST_PAYMENT_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

export function createGuestPayment(data) {
  return (dispatch) =>
    loadingCycle(api.post('/guest-payments', data))
      .then(({ data }) => dispatch(createGuestPaymentSuccess(data)))
      .catch((error) => dispatch(createGuestPaymentFail(error)));
}

export function createGuestPaymentSuccess(data) {
  return {
    type: CREATE_GUEST_PAYMENT_SUCCESS,
    data,
  };
}

export function createGuestPaymentFail(error) {
  return {
    type: CREATE_GUEST_PAYMENT_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}
